import styled from "styled-components";
import { WrapperContainer } from "../../../../../../components";

export const ClickableHeding = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  :disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const ScrolableContent = styled(WrapperContainer)`
  overflow-y: auto;
  padding-right: 4px;
`;
